// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageViewer_wrapper__f1KTU","image":"ImageViewer_image__mn-ad","fallbackImage":"ImageViewer_fallbackImage__Gz4Jz"};